export const baseUrl = `${process.env.REACT_APP_API_URL}`;
export const clientUrl = `https://eae-c3pay-apigw-p.azure-api.net`;
//  user Profile
export const getSalaryProfile = baseUrl + "/api/SalaryAdvance/profile";
// Salary advance Details
export const getSalaryAdvancedetails =
  clientUrl + "/salary-advance/v3/salary-advance-details";

//Salary history
export const getSalaryHistory = clientUrl + "/salary-advance/v3/salary-history";
// Check Eligibilty
export const checkEligibilty =
  clientUrl + "/salary-advance/v3/check-eligibility";
